(() => {
  function init(root) {
    if (!root || root.dataset.sf21Ready === 'true') return;
    root.dataset.sf21Ready = 'true';

    const stage = root.querySelector('.d17-stage');
    const buttons = [...root.querySelectorAll('[data-select]')];
    const flavours = buttons.map((button) => ({
      id: button.dataset.select,
      name: button.dataset.name,
      taste: button.dataset.taste,
      productLabel: button.dataset.productLabel,
    }));
    const flavourNav = root.querySelector('.d17-flavours');
    const rolls = [...root.querySelectorAll('[data-roll]')];
    const backgrounds = [...root.querySelectorAll('[data-background]')];
    const product = root.querySelector('.d19-product');
    const productName = root.querySelector('.d17-product__name');
    const productTaste = root.querySelector('.d17-product__taste');
    const ambientAudio = root.querySelector('audio');
    const soundButton = root.querySelector('.d18-sound');
    const soundLabel = root.querySelector('.d18-sound__label');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileProduct = window.matchMedia('(max-width: 620px)');
    const soundOnLabel = root.dataset.soundOnLabel || 'Sound on';
    const soundOffLabel = root.dataset.soundOffLabel || 'Sound off';

    if (!stage || !buttons.length || !product || !productName || !productTaste) return;

    let current = 0;
    let timer;
    let swipeStart = null;

    const syncProductMode = () => {
      root.dataset.productRender = mobileProduct.matches ? 'b' : 'a';
    };

    const activate = (index) => {
      current = (index + flavours.length) % flavours.length;
      const flavour = flavours[current];
      root.dataset.flavour = flavour.id;
      stage.dataset.cycle = String(Date.now());
      productName.textContent = flavour.name;
      productTaste.textContent = flavour.taste;
      product.setAttribute('aria-label', flavour.productLabel);

      buttons.forEach((button, buttonIndex) => {
        const active = buttonIndex === current;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      rolls.forEach((roll) => roll.classList.toggle('is-active', roll.dataset.roll === flavour.id));
      backgrounds.forEach((background) => {
        background.classList.toggle('is-active', background.dataset.background === flavour.id);
      });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };

    const start = () => {
      stop();
      if (!reduceMotion.matches && !document.hidden) {
        timer = window.setInterval(() => activate(current + 1), 5500);
      }
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        activate(index);
        start();
      });
    });

    stage.addEventListener('touchstart', (event) => {
      if (event.target.closest?.('button, a')) return;
      const touch = event.changedTouches[0];
      swipeStart = { x: touch.clientX, y: touch.clientY };
      stop();
    }, { passive: true });

    stage.addEventListener('touchend', (event) => {
      if (!swipeStart) return;
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - swipeStart.x;
      const deltaY = touch.clientY - swipeStart.y;
      swipeStart = null;
      if (Math.abs(deltaX) >= 44 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
        activate(current + (deltaX < 0 ? 1 : -1));
      }
      start();
    }, { passive: true });

    soundButton?.addEventListener('click', async () => {
      const shouldEnable = soundButton.getAttribute('aria-pressed') !== 'true';

      if (shouldEnable && ambientAudio) {
        ambientAudio.muted = false;
        try {
          await ambientAudio.play();
        } catch {
          ambientAudio.muted = true;
          return;
        }
      } else if (ambientAudio) {
        ambientAudio.muted = true;
      }

      soundButton.setAttribute('aria-pressed', String(shouldEnable));
      if (soundLabel) soundLabel.textContent = shouldEnable ? soundOnLabel : soundOffLabel;
    });

    flavourNav?.addEventListener('pointerenter', stop);
    flavourNav?.addEventListener('pointerleave', start);
    stage.addEventListener('focusin', stop);
    stage.addEventListener('focusout', (event) => {
      if (!stage.contains(event.relatedTarget)) start();
    });

    const visibilityHandler = () => start();
    document.addEventListener('visibilitychange', visibilityHandler);
    reduceMotion.addEventListener?.('change', start);
    mobileProduct.addEventListener?.('change', syncProductMode);

    root.sf21Destroy = () => {
      stop();
      document.removeEventListener('visibilitychange', visibilityHandler);
      reduceMotion.removeEventListener?.('change', start);
      mobileProduct.removeEventListener?.('change', syncProductMode);
      if (ambientAudio) ambientAudio.pause();
      delete root.dataset.sf21Ready;
    };

    syncProductMode();
    start();
  }

  document.querySelectorAll('[data-sf21-root]').forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[data-sf21-root]'));
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelector('[data-sf21-root]')?.sf21Destroy?.();
  });
})();
